class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
          .then((response) => response.text())
          .then((responseText) => {
        	
      });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
      Shopify.getCart((cart) => {window.sharedFunctions?.updateSidebarCart(cart)});
    })
  }
}

customElements.define('coupon-code', CouponCode);

/* Upsell Add-to-Cart — adds variant, refreshes sidebar via AJAX */
(function initUpsellATC() {
  function updateUpsellPanelVisibility() {
    var panel = document.getElementById('cart-sidebar-upsells');
    if (!panel) return;
    var sidebar = document.getElementById('halo-cart-sidebar');

    var visibleUpsellCount = panel.querySelectorAll('.upsell-item').length;
    var isEmpty = visibleUpsellCount === 0;

    panel.classList.toggle('is-empty', isEmpty);
    panel.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
    panel.setAttribute('data-upsell-count', String(visibleUpsellCount));

    if (sidebar) {
      sidebar.classList.toggle('has-upsells', !isEmpty);
    }
  }

  function bindUpsellSliderArrow() {
    var panel = document.getElementById('cart-sidebar-upsells');
    if (!panel) return;

    var list = panel.querySelector('.cart-sidebar-upsells__list');
    var nextButton = panel.querySelector('[data-upsell-next]');
    if (!list || !nextButton || nextButton.dataset.upsellSliderBound) return;

    nextButton.dataset.upsellSliderBound = 'true';
    nextButton.addEventListener('click', function(event) {
      event.preventDefault();

      if (!window.matchMedia('(max-width: 1024px)').matches) return;

      var firstCard = list.querySelector('.upsell-item');
      var step = firstCard ? Math.round(firstCard.getBoundingClientRect().width + 10) : Math.round(list.clientWidth * 0.9);
      list.scrollBy({ left: step, behavior: 'smooth' });
    });
  }

  function setUpsellButtonState(button, state) {
    if (!button) return;
    if (!button.dataset.defaultHtml) button.dataset.defaultHtml = button.innerHTML;
    if (!button.dataset.defaultAriaLabel) button.dataset.defaultAriaLabel = button.getAttribute('aria-label') || 'Add to cart';

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.classList.remove('is-added');
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span class="upsell-item__atc-text">...</span>';
      return;
    }

    if (state === 'added') {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.disabled = true;
      button.setAttribute('aria-busy', 'false');
      button.setAttribute('aria-label', 'Added');
      button.innerHTML = '<span class="upsell-item__atc-check">✓</span>';
      return;
    }

    button.classList.remove('is-loading', 'is-added');
    button.disabled = false;
    button.setAttribute('aria-busy', 'false');
    button.setAttribute('aria-label', button.dataset.defaultAriaLabel);
    button.innerHTML = button.dataset.defaultHtml;
  }

  function bindUpsellButtons() {
    document.querySelectorAll('[data-upsell-atc]').forEach(function(btn) {
      if (btn.dataset.upsellBound) return;
      btn.dataset.upsellBound = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var button = e.currentTarget;
        var variantId = button.dataset.variantId;
        if (!variantId || button.disabled) return;

        setUpsellButtonState(button, 'loading');

        fetch(window.routes.root + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('Upsell add failed');
          return res.json();
        })
        .then(function() {
          setUpsellButtonState(button, 'added');
          var upsellCard = button.closest('.upsell-item');
          if (upsellCard) {
            upsellCard.classList.add('is-added');
            setTimeout(function() {
              if (upsellCard && upsellCard.parentNode) {
                upsellCard.remove();
                updateUpsellPanelVisibility();
              }
            }, 320);
          }

          if (typeof Shopify !== 'undefined' && Shopify.getCart) {
            Shopify.getCart(function(cart) {
              if (window.sharedFunctions && window.sharedFunctions.updateSidebarCart) {
                window.sharedFunctions.updateSidebarCart(cart);
              } else if (typeof halo !== 'undefined' && halo.updateSidebarCart) {
                halo.updateSidebarCart(cart);
              }
            });
          }
        })
        .catch(function() {
          setUpsellButtonState(button, 'idle');
        });
      });
    });
  }

  /* Bind on initial load */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      bindUpsellButtons();
      bindUpsellSliderArrow();
      updateUpsellPanelVisibility();
    });
  } else {
    bindUpsellButtons();
    bindUpsellSliderArrow();
    updateUpsellPanelVisibility();
  }

  /* Re-bind after AJAX cart updates (sidebar HTML gets replaced) */
  document.addEventListener('cart-update', function() {
    bindUpsellButtons();
    bindUpsellSliderArrow();
    updateUpsellPanelVisibility();
  });
  document.addEventListener('theme.cart.drawer.loaded', function() {
    bindUpsellButtons();
    bindUpsellSliderArrow();
    updateUpsellPanelVisibility();
  });
})();
